import { useMemo } from 'react';

import { useUseBoardListsQuery } from './UseBoardListsQuery.generated';

export const useBoardLists = ({ idBoard }: { idBoard: string }) => {
  const { data, loading } = useUseBoardListsQuery({
    variables: {
      idBoard,
    },
    waitOn: ['CurrentBoardFull'],
  });

  const lists = useMemo(() => data?.board?.lists ?? [], [data?.board?.lists]);

  return { lists, loading };
};
